__turbopack_context__.v({
  "arrow": "VF9nqa_arrow",
  "item": "VF9nqa_item",
});
